import { styled, css } from 'styled-components';

const StyledSideBar = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: fixed;
  top: ${(props) => props.theme.headerBarHeight};
  right: 0;
  height: 100vh;
  width: 100%;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  z-index: 10;
  background-color: ${(props) => props.theme.colors.primary};
  padding: 0 20px;

  ${(props) =>
    props.isOpen &&
    css`
      transform: translateX(0);
    `}
  
  // small screens
  @media only screen and (min-width: ${(props) => props.theme.screenSizeBreakpoints.s}) {
    max-width: 400px;
    border-left: 1px solid ${(props) => props.theme.colors.secondary};
  }

  // medium and up screens
  @media only screen and (min-width: ${(props) => props.theme.screenSizeBreakpoints.m}) {
    position: sticky;
    top: ${(props) => props.theme.headerBarHeight};
    width: 400px !important;
    transform: none;
    transition: none;
    background-color: transparent;
    overflow-y: scroll;
    scrollbar-width: none;
    height: calc(100vh - ${(props) => props.theme.headerBarHeight});
    min-height: calc(100vh - ${(props) => props.theme.headerBarHeight});
    scroll-padding-top: 80px;
    align-self: flex-start;

    &:hover {
      overflow-y: auto;
    }
  }
`;

export { StyledSideBar };
